export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-csv-a24e347b25192abe2278a8d183f46ede.svg";